/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsCart = {
    init: function ($section) {

      // Add settings from schema to current object
      //Shopify.theme.jsCart = $.extend(this, Shopify.theme.getSectionData($section));

      this.$section = $section;

      $(document).on('click', '[data-cart-page-delete]', function (e) {
        e.preventDefault();
        const lineID = $(this).data('line-item-key');
        Shopify.theme.jsCart.removeFromCart(lineID);

        return false;
      });

      $(document).on('click', '.linkedDeleteBtn', function (e) {
        e.preventDefault();
        var needToRemoveItems = $(this).attr("data-linkedbutton");
        $(needToRemoveItems).addClass("fadeItem");
        var lineItemsToRemove = {};


        var formData = new FormData();

        $(needToRemoveItems).each(function () {
          var lineItem = $(this).attr("data-cart-item");
          lineItemsToRemove[lineItem] = 0;
          formData.append(`updates[${lineItem}]`, 0);
        });
        // Make the AJAX request to update the cart
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData
        }).then(response => {
            console.log(JSON.stringify(response));
            location.reload();
            return response.json();
          })
          .then(data => console.log(data));


      });

      // Prevent the ajax cart form from being submitted when pressing the "Enter" key
      $('#cart_form').keydown(function (e) {
        if (e.keyCode == 13) {
          e.preventDefault();
          return false;
        }
      });
    },
    removeFromCart: function (lineID) {
      const $cartItem = Shopify.theme.jsCart.$section.find(`[data-line-item="${lineID}"]`);

      $cartItem.css('opacity', '0.5');

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&line=' + lineID,
        dataType: 'json',
        success: function (cart) {

          $cartItem.addClass('animated zoomOut')
          $cartItem.remove();

          Shopify.theme.jsCart.updateView(cart, lineID);

          if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
            Shopify.theme.jsAjaxCart.updateView();
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
        }
      });
    },
    updateView: function (cart, lineID) {

      if (cart.item_count > 0) {
        $.ajax({
          dataType: "json",
          async: false,
          cache: false,
          dataType: 'html',
          url: "/cart",
          success: function (html) {

            if (lineID !== null) {

              const updatedItems = $(html).find('.cart__item-list .cart__card');
              const currentItems = $('.cart__item-list .cart__card');

              // Checks if BOGO applied and there is a change in the number of line items
              if (updatedItems.length != currentItems.length) {
                const updatedCartList = $(html).find('.cart__item-list');
                // Re-append cart items
                $('.cart__item-list').replaceWith(updatedCartList);
              }

              $(currentItems).each(function (index, element) {
                $(element).attr('data-line-item', (index + 1));
                $(element).find('[data-line-item-key]').attr('data-line-item-key', (index + 1));
              })

              const itemTotal = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__total');
              const quantityInput = $(html).find(`[data-line-item="${lineID}"]`).find('.quantity-input');
              const itemPrice = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__price');

              $(`[data-line-item="${lineID}"]`).find('.cart__total').replaceWith(itemTotal);
              $(`[data-line-item="${lineID}"]`).find('.quantity-input').replaceWith(quantityInput);
              $(`[data-line-item="${lineID}"]`).find('.cart__price').replaceWith(itemPrice);

            }

            const subtotal = $(html).find('.cart__footer');

            $('.cart__footer').replaceWith(subtotal);

            if (typeof window.initStudentValidation === 'function') {
              window.initStudentValidation();
            }

            $('[data-bind="itemCount"]').text(cart.item_count);

          }
        });

      } else {
        $('.cart__empty-cart-message').removeClass('is-hidden');
        $('.cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

    },
    unload: function ($section) {
      // Clear event listeners in theme editor
      $('[data-cart-page-delete]').off();
      $('#cart_form').off();
    }
  }

  /******/
})()
  ;